import React from 'react';
import {Form, FormGroup, ControlLabel, FormControl, Button, Col, Modal, ModalFooter, Table} from 'react-bootstrap';
import {connect} from 'react-redux';
import {API_URL} from '../../../../../../services/Api/constants';
import PropTypes from 'prop-types';
import './styles.css'
import {Redirect} from 'react-router-dom'
import _ from 'lodash';
import {personFullName} from "../../../../../../services/Api";
import {Editor} from 'react-draft-wysiwyg';
import {EditorState, convertToRaw, ContentState} from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from "html-to-draftjs";
import ReactTags from 'react-tag-autocomplete'


class MailForm extends React.Component {

    loadingId = '@Class.AddressForm.Address.create';
    static contextTypes = {api: PropTypes.object, notifier: PropTypes.object};

    constructor(props, context) {
        super(props);
        context.api.emailTemplates.get(0, 200, '@Class.emailTemplates.emailTemplates.get');
        this.baseUrl = API_URL;
        if (props.creating) {
            this.state = {
                form: {
                    subject: '',
                    body: EditorState.createEmpty(),
                    to: [],
                    excludedEmailAddresses: [],
                    sentDate: null,
                    header: null,
                    footer: null,
                    emailAddresses: [],
                    mailerTags: [],
                    people: [],
                    toTest: [],
                    plainEmails: [],
                    attachments: [],
                },
                searchReceiver: '',
                suggestions: [],
                sendingTest: false,
                files: []
            };
        } else if (props.forwarding) {
            const blocksFromHtml = htmlToDraft(this.props.forwarding.body);
            const {contentBlocks, entityMap} = blocksFromHtml;
            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
            const editorState = EditorState.createWithContent(contentState);
            this.state = {
                form: {
                    header: props.forwarding.header,
                    footer: props.forwarding.footer,
                    sentDate: null,
                    to: this.getReceivers(this.props.forwarding),
                    excludedEmailAddresses: [],
                    emailAddresses: props.forwarding.emailAddresses,
                    mailerTags: [],
                    people: [],
                    plainEmails: [],
                    subject: props.forwarding.subject,
                    body: editorState,
                    toTest: [],
                    attachments: props.forwarding.attachments ? props.forwarding.attachments : null,
                },
                searchReceiver: '',
                suggestions: [],
                sendingTest: false,
                files: []
            };
        } else if (props.editing) {
            const blocksFromHtml = htmlToDraft(this.props.editing.body);
            const {contentBlocks, entityMap} = blocksFromHtml;
            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
            const editorState = EditorState.createWithContent(contentState);
            this.state = {
                form: {
                    id: props.editing.id,
                    header: props.editing.header,
                    footer: props.editing.footer,
                    emailAddresses: props.editing.emailAddresses,
                    mailerTags: props.editing.mailerTags,
                    people: props.editing.people,
                    plainEmails: props.editing.plainEmails,
                    subject: props.editing.subject,
                    body: editorState,
                    toTest: [],
                    to: this.getReceivers(this.props.editing),
                    excludedEmailAddresses:
                        props.editing.excludedEmailAddresses
                        ? props.editing.excludedEmailAddresses.map( e => ({name: e}) )
                        : [],
                    attachments: props.editing.attachments,
                },
                searchReceiver: '',
                suggestions: [],
                sendingTest: false,
                files: []
            };
        }
        this.loadReceivers = _.debounce(this.loadReceivers, 250);

    }

    getHeader = () => {
        return _.find(this.props.emailTemplates, (emailTemplate) => emailTemplate.type === 'header')
    };

    getFooter = () => {
        return _.find(this.props.emailTemplates, (emailTemplate) => emailTemplate.type === 'footer')
    };

    onEditorStateChange = (editorState) => this.setState({form: {...this.state.form, body: editorState}});

    onReceiverChange = (receiver) => {
        this.setState({searchReceiver: receiver});
        this.loadReceivers()
    };

    loadReceivers = () => {
        const filterEmail = {"email": this.state.searchReceiver, "active": true};
        const filterName = {"name": this.state.searchReceiver};
        this.context.api.emailAddresses.get(0, 100, '@Class.emailAddresses.emailAddresses.get', filterEmail);
        this.context.api.mailerTags.get(0, 100, '@Class.MailerTags.mailerTags.get', filterName);
        this.context.api.people.get(0, 1000, undefined, {...filterName, ...{"membership[exists]": true}}).then((people = []) => people.map((person) => ({
            value: person.membership.id,
            label: personFullName(person)
        })))
    };

    getReceivers = (e) => {
        const {mailerTags, emailAddresses, people, plainEmails} = e;
        let emails = [], ppl = [], tags = [], plain = [];
        if (emailAddresses) emails = emailAddresses.map(ea => {
            return {'id': ea.id + "-email", 'name': ea.email, 'icon': "fa fa-address-book-o"}
        });
        if (people) ppl = people.map(p => {
            return {'id': p.id + "-people", 'name': personFullName(p), 'icon': "fa fa-users"}
        });
        if (mailerTags) tags = mailerTags.map(t => {
            return {'id': t.id + "-tag", 'name': t.name, 'icon': "fa fa-tag"}
        });
        if (this.props.editing && plainEmails) plain = plainEmails.map(p => {
            return {'name': p}
        });
        return emails.concat(tags, ppl, plain);
    };

    onFormChange = ({target}) => this.setState({form: {...this.state.form, [target.name]: target.value}});

    getFormValue = (name) => {
        return this.state.form[name] ? this.state.form[name] : ''
    };

    handleDeleteExcluded = (tag) => {
        const excludedEmailAddresses = this.state.form.excludedEmailAddresses.filter(t => t.name !== String(tag));
        this.setState({form: {...this.state.form, excludedEmailAddresses: excludedEmailAddresses}})
    };

    handleAdditionExcluded = (tag) => {
        const excludedEmailAddresses = [...this.state.form.excludedEmailAddresses];
        let tagExists = false;
        for (let i = 0; i < excludedEmailAddresses.length; i++) {
            if (tag.id === undefined) {
                if (excludedEmailAddresses[i].name === tag.name) return tagExists
            } else {
                if (excludedEmailAddresses[i].name === tag.name) return tagExists = true;
            }
        }
        if (excludedEmailAddresses < 1 || tagExists === false) excludedEmailAddresses.push(tag);
        return this.onFormChange({target: {name: 'excludedEmailAddresses', value: excludedEmailAddresses}})
    };

    handleDeleteTag = (tag) => {
        const to = this.state.form.to.filter(t => t.name !== String(tag));
        this.setState({form: {...this.state.form, to: to}})
    };

    handleAdditionTag = (tag) => {
        const to = [...this.state.form.to];
        let tagExists = false;
        for (let i = 0; i < to.length; i++) {
            if (tag.id === undefined) {
                if (to[i].name === tag.name) return tagExists
            } else {
                if (to[i].id === tag.id) return tagExists = true;
            }
        }
        if (to < 1 || tagExists === false) to.push(tag);
        return this.onFormChange({target: {name: 'to', value: to}})
    };

    cleanReceivers = (receivers) => {
        let mailDirections = [], plainEmails = [], people = [], tags = [];
        for (let i = 0; i < receivers.length; i++) {
            if (!receivers[i].id) plainEmails.push(receivers[i].name);
            else {
                let id = receivers[i].id.toString();
                if (id.includes('-email')) mailDirections.push(Number(id.split('-')[0]));
                else if (id.includes('-people')) people.push(Number(id.split('-')[0]));
                else if (id.includes('-tag')) tags.push(Number(id.split('-')[0]));
            }
        }
        return {'emailAddresses': mailDirections, 'mailerTags': tags, 'people': people, 'plainEmails': plainEmails}
    };

    packEmailDocument = () => {
        const emailDocument = {...this.state.form};

        if (emailDocument.subject === "") return this.context.notifier.error('Falta asunto');
        if (!emailDocument.body) return this.context.notifier.error('Falta contenido de correo');

        const cleanReceivers = this.cleanReceivers(emailDocument.to);
        emailDocument.emailAddresses = cleanReceivers.emailAddresses;
        emailDocument.mailerTags = cleanReceivers.mailerTags;
        emailDocument.people = cleanReceivers.people;
        emailDocument.plainEmails = cleanReceivers.plainEmails;
        emailDocument.header = this.getHeader() ? this.getHeader().id : undefined;
        emailDocument.footer = this.getFooter() ? this.getFooter().id : undefined;
        let excludedEmailAddresses = [];
        for (let i = 0; i < this.state.form.excludedEmailAddresses.length; i++) {
            excludedEmailAddresses.push(this.state.form.excludedEmailAddresses[i].name);
        }
        emailDocument.excludedEmailAddresses = excludedEmailAddresses;
        const rawContentState = convertToRaw(emailDocument.body.getCurrentContent());
        let htmlText = draftToHtml(rawContentState);
        let htmlConverted = this.convertImages(htmlText);
        emailDocument.body = htmlConverted;
        const newAttachments = [...emailDocument.attachments];
        emailDocument.attachments = newAttachments.map((att) => att.id);
        return emailDocument
    };

    convertImages = (htmlText) => {
        const regex = /<img\s[^>]*?style\s*=\s*['"]float([^'"]*?)['"][^>]*?>/g;
        let m;
        while ((m = regex.exec(htmlText)) !== null) {
            if (m.index === regex.lastIndex) regex.lastIndex++;
            let repl = null, type = null;

            //eslint-disable-next-line
            m.forEach((match, groupIndex) => {
                if (groupIndex === 0) repl = match;
                if (groupIndex === 1) type = match;
                if (repl && type) {
                    if (type.includes('none')) htmlText = htmlText.replace(repl, `<div style="text-align: center;width: 100%;">` + repl + '</div>');
                    else htmlText = htmlText.replace(repl, `<div style="text-align ${type}; width: 100%;">` + repl + '</div>');
                    repl = null;
                    type = null;
                }
            });
        }
        return htmlText;
    }

    send = (e) => {
        e.preventDefault();
        if (e.target.name === 'test') {
            //eslint-disable-next-line
            const re = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
            if (this.state.form.test === '' || re.test(String(this.state.form.toTest).toLowerCase()) === false) return this.context.notifier.error('Introduzca un email válido para enviar la prueba.');
        }
        let document = this.packEmailDocument();
        if (!this.state.form.id) {
            this.saveDraft(document).then((r) => {
                return this.sendEmail(r)
            });
        } else this.context.api.emailDocuments.edit(this.state.form.id, document, this.loadingId)
            .then(() => {
                return this.sendEmail(this.state.form.id)
            });
    };

    saveDraft = () => {
        let document = this.packEmailDocument();

        //Get all File s from the FileList s inside the files object of the state
        const files = [];
        for (let i = 0; i < this.state.files.length; i++)
            if (this.state.files[i] && this.state.files[i].length)
                for (let j = 0; j < this.state.files[i].length; j++)
                    files.push(this.state.files[i][j])

        if (!this.state.form.id)
            return this.context.api.emailDocuments.create(document, this.loadingId, files)
                .then((res) => {
                    this.setState({form: {...this.state.form, id: res.id, attachments: res.attachments}});
                    return res.id;
                });
        else
            return this.context.api.emailDocuments.edit(this.state.form.id, document, this.loadingId, files)
                .then(() => {
                    this.context.notifier.success('Guardado');
                    if (this.props.onHide)
                        this.props.onHide();
                    else
                        this.setState({redirectToBin: true});
                })
    };

    sendEmail = (idEmailDocument) => {
        if (this.state.sendingTest === true) {
            return this.context.api.emailDocuments.sendTest(idEmailDocument, {'plainEmails': [this.state.form.toTest]}, '@sendTest')
                .then(() => {
                    this.context.notifier.success('Prueba Enviada');
                    return this.onHide();
                });
        }
        return this.context.api.emailDocuments.sendEmail(idEmailDocument, {}, undefined)
            .then(() => {
                this.setState({redirectToBin: true});
                return this.context.notifier.success('Correo Enviado');
            })
    };

    testMail = () => {
        if (this.state.form.subject === "") return this.context.notifier.error('Falta asunto');
        this.setState({sendingTest: true})
    };

    onHide = () => this.setState({sendingTest: false});

    addFile = () => this.setState({files: [...this.state.files, {key: Math.random()}]});

    onFileChange = ({target}) => {
        const files = [...this.state.files];
        const key = files[target.dataset.index].key;
        files[target.dataset.index] = target.files;
        files[target.dataset.index].key = key;
        this.setState({files});
    };

    removeNewFile = ({target}) => {
        const files = [...this.state.files];
        files.splice(target.dataset.index, 1);
        this.setState({files});
    };

    downloadFile = ({target}) => {
        const fileId = target.dataset.id;
        this.context.api.appFiles.download(fileId);
    };

    removeOldFile = ({target}) => {
        const fileIndex = target.dataset.index;
        const oldFiles = [...this.state.form.attachments];
        oldFiles.splice(fileIndex, 1);
        this.setState({form: {...this.state.form, attachments: oldFiles}});
    };

    uploadImageEditor = (file) => {
        return new Promise(
            async (resolve, reject) => {
                try {
                    const response = await this.context.api.appFiles.create(null, false, undefined, file);
                    response.data = {};
                    response.data.link = this.baseUrl + "/file/" + response.id;
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            })
    };

    showDetails = (e) => {
        if (!e.id.includes('-tag')) return null;
        let idTag = Number(e.id.split('-')[0]);
        this.setState({detailingTag: e});
        if (e.id.includes('-tag')) {
            this.context.api.emailAddresses.get(0, 200, '', {'mailerTags.id': idTag, 'sGroups':["email_address_read"]}, 'filteredEmailAddresses');
            this.context.api.people.get(0, 200, '', {'mailerTags.id': idTag, 'sGroups':["person_simple"]}, 'filteredPeople');
        }
    };

    onHideDetailingTag = () => {
        this.context.api.clearProperty('filteredEmailAddresses');
        this.context.api.clearProperty('filteredPeople');
        this.setState({detailingTag: null});
    };

    excludeEmail = (emailDirection) => {
        let excludedEmailAddresses = this.state.form.excludedEmailAddresses;
        if (excludedEmailAddresses < 1 || !this.validateExistence(emailDirection)) excludedEmailAddresses.push({name: emailDirection});
        this.setState({excludedEmailAddresses: excludedEmailAddresses})
    };

    validateExistence = emailDirection => this.state.form.excludedEmailAddresses.map(o => o.name).includes(emailDirection);

    createTable = () => {
        let table = [];
        const contactsInTag = this.props.filteredEmailAddresses.concat(this.props.filteredPeople);
        contactsInTag.map((tag, key) => {
            return table.push(<tr key={key} className={this.validateExistence(tag.email) ? 'excluded' : ''}>
                <td>{tag.name}</td>
                <td>{tag.email}</td>
                <td><i className={"fa fa-ban erase-file-icon " + (this.validateExistence(tag.email) ? 'disabled' : '')}
                       aria-hidden="true" onClick={() => this.excludeEmail(tag.email)}/></td>
            </tr>)
        });
        return table
    };

    render() {
        const header = this.getHeader();
        const footer = this.getFooter();
        let suggestions = this.getReceivers(this.props);

        return (
            <div className="container-fluid MailForm">
                <div className="row">
                    <div className="col-md-12">
                        <Form horizontal>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={2}>*&nbsp;Destinatarios:</Col>
                                <Col sm={10}>
                                    <ReactTags tags={this.getFormValue('to')}
                                               placeholder=''
                                               autofocus={true}
                                               className='tagsInput'
                                               allowBackspace={true}
                                               allowNew={true}
                                               suggestions={suggestions}
                                               handleDelete={this.handleDeleteTag}

                                               handleAddition={this.handleAdditionTag}
                                               name='to'
                                               handleInputChange={this.onReceiverChange}
                                               tagComponent={(props) => (
                                                   <div className='react-tag-personalized'>
                                                        <span onClick={() => this.showDetails(props.tag)}>
                                                            <i className={props.tag.icon}/>
                                                            {props.tag.name}
                                                        </span>
                                                        <span className='reactDeleteButton'
                                                             onClick={() => this.handleDeleteTag(props.tag.name)}>&#10005;
                                                        </span>
                                                   </div>
                                               )}/>
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalExcludedEmailDirections">
                                <Col componentClass={ControlLabel} sm={2}>*&nbsp;Excluir:</Col>
                                <Col sm={10}>
                                    <ReactTags
                                        tags={this.getFormValue('excludedEmailAddresses') ? this.getFormValue('excludedEmailAddresses') : null}
                                        placeholder=''
                                        autofocus={false}
                                        className='tagsInput'
                                        allowBackspace={true}
                                        allowNew={true}
                                        handleDelete={this.handleDeleteExcluded}
                                        handleAddition={this.handleAdditionExcluded}
                                        name='excludedEmailAddresses'
                                        tagComponent={(props) =>
                                            <div className='react-tag-personalized'>
                                                <span><i className={props.tag.icon}/>{props.tag.name}</span>
                                                <span className='reactDeleteButton'
                                                      onClick={() => this.handleDeleteExcluded(props.tag.name)}>&#10005;
                                                   </span>
                                            </div>}/>
                                </Col>
                            </FormGroup>
                            <FormGroup>
                                <Col componentClass={ControlLabel} sm={2}>*&nbsp;Asunto:</Col>
                                <Col sm={10}>
                                    <FormControl
                                        name='subject'
                                        value={this.getFormValue('subject')}
                                        onChange={this.onFormChange}
                                        required/>
                                </Col>
                            </FormGroup>
                            <hr/>

                            <FormGroup>
                                <div className='contEditor centered'>
                                    {header ? <div className='header'
                                                   dangerouslySetInnerHTML={{__html: header.html}}/> : null}
                                    <Editor
                                        toolbar={{
                                            options: ['inline', 'fontFamily', 'fontSize', 'textAlign', 'list', 'colorPicker', 'link', 'history', 'image'],
                                            image: {
                                                className: 'imageEmail',
                                                urlEnabled: true,
                                                uploadEnabled: true,
                                                uploadCallback: this.uploadImageEditor,
                                                defaultSize: {height: "100", width: "auto"},
                                                previewImage: true,
                                                alt: {present: true, mandatory: false}
                                            },
                                            list: {
                                                inDropdown: false,
                                                options: ['unordered', 'ordered']
                                            },
                                            inline: {
                                                inDropdown: false,
                                                options: ['bold', 'italic', 'underline', 'superscript', 'subscript'],
                                            },
                                        }}
                                        editorState={this.getFormValue('body')}
                                        name='body'
                                        className='editor'
                                        wrapperClassName="wrapper-class"
                                        editorClassName="editor-class"
                                        toolbarClassName="toolbar-class"
                                        onEditorStateChange={this.onEditorStateChange}/>
                                    {footer ? <div className='footerMail'
                                                   dangerouslySetInnerHTML={{__html: footer.html}}/> : null}
                                </div>
                            </FormGroup>
                            <hr/>
                            <div className='attachments-well'>
                                {
                                    this.state.form.attachments.map((file, index) =>
                                        <p key={file.id} className='old-file'><span onClick={this.downloadFile}
                                                                                    data-id={file.id}>{file.originalName}</span>
                                            <i className='fa fa-trash erase-file-icon' data-index={index}
                                               onClick={this.removeOldFile}/></p>
                                    )
                                }
                                {this.state.files.map((f, i) =>
                                    <p key={f.key}><input type='file' data-index={i} onChange={this.onFileChange}/> <i
                                        className='fa fa-trash erase-file-icon' onClick={this.removeNewFile}
                                        data-index={i}/></p>
                                )}
                                <span className='link' onClick={this.addFile}>Agregar archivo adjunto</span><br/>
                            </div>
                            <hr/>
                            <Button className='buttonsMail'
                                    bsStyle='warning'
                                    onClick={this.saveDraft}>Guardar Borrador</Button>
                            <Button bsStyle='success'
                                    className='pull-right'
                                    onClick={this.send}>Enviar</Button>
                            <Button className='pull-right buttonsMail testMail'
                                    bsStyle='info'
                                    onClick={this.testMail}>Enviar correo de Prueba</Button>
                        </Form>
                    </div>
                </div>
                {this.state.sendingTest ?
                    <Modal show={true}
                           onHide={this.onHide}
                           className="MailForm">
                        <Modal.Header closeButton>
                            <Modal.Title>Enviar correo de Prueba</Modal.Title>
                        </Modal.Header>
                        <Form horizontal onSubmit={this.send} name='test'>
                            <Modal.Body>
                                <FormGroup controlId="formHorizontalEmail">
                                    <Col componentClass={ControlLabel} sm={2}>*&nbsp;Destinatario:</Col>
                                    <Col sm={10}>
                                        <input onChange={this.onFormChange} placeholder='Correo de destinatario prueba'
                                               name='toTest' className='toTest'/></Col>
                                </FormGroup>
                            </Modal.Body>
                            <ModalFooter>
                                <Button
                                    bsStyle='success'
                                    className='pull-right'
                                    type="submit">Enviar</Button>
                            </ModalFooter>
                        </Form>
                    </Modal>
                    : null}
                {this.state.redirectToBin ? <Redirect to='/mailManager/emails'/> : null}

                {this.state.detailingTag && <Modal show={true} onHide={this.onHideDetailingTag} className="MailForm">
                    <Modal.Header>
                        <span><i className={this.state.detailingTag.icon}/>&nbsp;{this.state.detailingTag.name}</span>
                    </Modal.Header>
                    <Modal.Body>
                        <Table style={{fontSize: '1.2rem'}}>
                            <thead>
                            <tr>
                                <th><b>Nombre</b></th>
                                <th><b>Correo electrónico</b></th>
                                <th><b>Excluir</b></th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.createTable()}
                            </tbody>
                        </Table>
                    </Modal.Body>
                    <ModalFooter>
                        <Button bsStyle='success' className='pull-right'
                                onClick={this.onHideDetailingTag}>Cerrar</Button>
                    </ModalFooter>
                </Modal>}
            </div>
        );
    }
}

const mapStateToProps = ({api: {emailTemplates = [], mailerTags = [], emailAddresses = [], people = [], filteredPeople = [], filteredEmailAddresses = []}, loadingIds}) => ({
    emailTemplates,
    emailAddresses,
    mailerTags,
    people,
    loadingIds,
    filteredPeople,
    filteredEmailAddresses
});

export default connect(mapStateToProps)(MailForm);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/MailManager/components/MailForm/index.jsx